import { Option, ReadonlyArray } from "@morphism/fp";

import { Graph, gql } from "~/Graph";
import { ID } from "~/ID";
import { Lifecycle } from "~/Lifecycle";
import { Media } from "~/Media";

export type Comment = {
  readonly comment: ID & Lifecycle.Submitted & { readonly text?: string };
};

export namespace Comment {
  export type Fragment = Graph.Generated.CommentFragment;
  export namespace Fragment {
    export const document = () => gql`
      ${Lifecycle.Submitted.Fragment.document()}
      ${Media.Fragment.document()}

      fragment Comment on Comment {
        id
        text
        ...Submitted
        ...Media
      }
    `;

    export const decode = (encoded: Fragment): Comment => ({
      comment: {
        ...ID.from(encoded.id),
        text: encoded.text ?? undefined,

        // TODO: Move to `Lifecycle`
        submitted: {
          dateTime: new Date(encoded.lifecycle.submitted.dateTime).valueOf(),

          ...("name" in encoded.lifecycle.submitted.actor && {
            name: encoded.lifecycle.submitted.actor.name ?? undefined,
          }),

          ...("userID" in encoded.lifecycle.submitted.actor &&
            encoded.lifecycle.submitted.actor.userID && {
              user: { id: encoded.lifecycle.submitted.actor.userID },
            }),
        },
      },
    });
  }
}

export type Comments = { readonly comments: readonly Comment[] };
export namespace Comments {
  export type Fragment = Graph.Generated.CommentsFragment;
  export namespace Fragment {
    export const document = () => gql`
      fragment Comments on Comment__HasMany {
        comments {
          ...Comment
        }
      }

      ${Comment.Fragment.document()}
    `;

    export const decode = (encoded: Fragment): Comments => ({
      comments: pipe(
        encoded.comments ?? [],
        ReadonlyArray.filterMap(
          flow(Option.fromNullable, Option.map(Comment.Fragment.decode))
        )
      ),
    });
  }
}
